import { fetch } from 'utils/fetch';
import axios from 'axios';
import config from 'config';
import util from '@/utils';
import { getBaseUrl, getH5Platform, isIOS } from '@/utils/environment';
import { NativeService } from '../../service/native/nativePluginService';
import { getQueryString } from '../../utils/environment';
import moment from 'moment';
import store from 'src/vuex';
import { Base64 } from 'js-base64';

let errText = {
  noArgs: '未传入有效参数',
};
// 查询申请单列表
export const getAllApplicationList = ({
  page,
  size,
  status,
  applicantOIDs,
  formOID,
  startDate,
  endDate,
  withCustomForm = true,
  withCustomFormProperty = true,
  withParticipant = true,
  withUserInfo = true,
}) => {
  return fetch({
    url: '/api/applications/v3/search',
    method: 'GET',
    params: {
      withCustomForm,
      withCustomFormProperty,
      withParticipant,
      withUserInfo,
      page,
      size,
      status,
      applicantOIDs,
      formOID,
      startDate,
      endDate,
    },
  });
};
// 申请单关闭列表查询/api/application/batch/budget/close
export const getCanDownApplicationList = ({ page, size }) => {
  return fetch({
    url: '/api/application/budget/close/list',
    method: 'GET',
    params: {
      page,
      size,
    },
  });
};
// 关闭申请单预算(批量关闭单据)
export const downApplicationBudget = (applicationOID) => {
  let applicationOIDs = [];
  applicationOIDs.push(applicationOID);
  return fetch({
    url: '/api/application/batch/budget/close',
    method: 'POST',
    data: {
      applicationOIDs: applicationOIDs,
    },
  });
};
// 关闭申请单预算(单个单据关闭,支持批量关闭分摊行)
export const downApplicationApportion = (params) => {
  return fetch({
    url: '/api/application/budget/close',
    method: 'POST',
    data: params,
  });
};
// 撤回申请单
export const postWithdrawApplication = (data) => {
  if (!data) return;
  return fetch({
    url: '/api/approvals/withdraw',
    method: 'POST',
    data: data,
  });
};
// 删除申请单
export const deleteApplication = (applicationOID, forceDelete = false) => {
  if (!applicationOID) return;
  return fetch({
    url: `/api/applications/all/${applicationOID}?forceDelete=${forceDelete}`,
    method: 'DELETE',
  });
};
// 停用申请单
export const postCloseApplication = (applicationOID, participantOID, reason) => {
  if (!applicationOID || !participantOID) {
    return;
  }
  return fetch({
    url: '/api/applications/close',
    method: 'POST',
    params: {
      applicationOID: applicationOID,
      participantOID: participantOID,
    },
    data: {
      remark: reason || '',
    },
  });
};
// 重新启用申请单
export const postRestartApplication = (applicationOID, participantOID, closeDay) => {
  return fetch({
    url: '/api/applications/restart',
    method: 'POST',
    params: {
      applicationOID,
      participantOID,
      closeDay,
    },
  });
};
// 判断是否可以升级申请单
export const getApplicationChangeEnable = (lastApplicationOID) => {
  return fetch({
    url: '/api/travel/application/change/enable',
    method: 'GET',
    params: {
      lastApplicationOID,
    },
  });
};

// 判断是否可以升级费用申请单
export const getExpenseApplicationChangeEnable = (lastApplicationOID) => {
  return fetch({
    url: '/api/expense/application/change/enable',
    method: 'GET',
    params: {
      lastApplicationOID,
    },
  });
};

// 判断是否可以升级对公申请单
export const getApRequestChangeEnable = (lastApplicationOID) => {
  return fetch({
    url: '/api/public/application/change/enable',
    method: 'GET',
    params: {
      lastApplicationOID,
    },
  });
};

// 获取本人可以创建的单据列表
export const getApplicationFormsCanSelect = (params) => {
  return fetch({
    url: '/api/custom/forms/my/available',
    method: 'GET',
    params,
  });
};
// 获取申请单详情
export const getApplicationDetail = (
  applicationOID = '',
  viewUserOID = undefined,
  withBudgetCloseStatus = false,
  recordOID = '',
  sceneCode
) => {
  if (!applicationOID) {
    return;
  }
  let params = {
    sceneCode,
    viewUserOID,
    showValue: true,
    travelOperationRecordOID: recordOID,
  };
  if (withBudgetCloseStatus) {
    params.withBudgetCloseStatus = withBudgetCloseStatus;
  }
  return fetch({
    url: `/api/application/${applicationOID}`,
    method: 'GET',
    params: params,
  });
};
// 是否可以加签
export const isCounterSignEnable = ({ companyOID, formOID, counterSignType }) => {
  if (!companyOID || !formOID) {
    return;
  }
  return fetch({
    url: '/api/countersign/addSign/enable',
    method: 'GET',
    params: {
      companyOID,
      formOID,
      counterSignType,
    },
    nativeResponseSerializer: 'boolean',
  });
};
// 通过userOID获取人员信息
export const getUserInfoByUserOIDs = (data) => {
  return fetch({
    url: `/api/users/oids?userOIDs=${data}`,
    method: 'GET',
  });
};
// 获取城市编码
export const getCityCode = ({
  cityName = '',
  lang = 'zh_cn',
  vendorType = 'standard',
  page = 0,
  country,
  roleType = 'TENANT',
  businessType,
}) => {
  if (!cityName) return;

  // 对供应商处理
  if (vendorType === 'heliosHotel') {
    vendorType = 'titancloud';
  }
  return fetch({
    url: '/location-service/api/custom/location/search/keyword',
    method: 'GET',
    params: {
      keyword: cityName,
      vendorType: vendorType,
      language: lang,
      country,
      size: 10,
      page,
      roleType,
      businessType,
    },
  });
  // if(lang == 'ch'){
  //     lang = 'zh_cn'
  // }else if(lang === 'en'){
  //     lang = 'en_us'
  // }
  // return fetch({
  //     url: '/location-service/api/location/search',
  //     method: 'GET',
  //     headers:{
  //         baceCountry: 'CHN',
  //         language: lang,
  //         country,
  //     },
  //     params:{
  //         vendorType,
  //         keyWord: cityName,
  //         type: 'CITY',
  //         page
  //     }
  // })
};
// 获取城市编码
export const getCityCodeV2 = ({
  cityName = '',
  lang = 'zh_cn',
  country = 'china',
  vendorType = 'standard', // 供应商 eg:携程 甄选
  businessType = '', // 行程类型（品类） eg:机票酒店火车
  typeCodeList = [],
  page = 0,
  size = 20,
}) => {
  if (!cityName) return;
  // 对供应商处理
  if (vendorType === 'heliosHotel') {
    vendorType = 'titancloud';
  }
  return fetch({
    url: '/location-service/api/custom/location/search/keyword/V2',
    method: 'GET',
    params: {
      keyword: cityName,
      vendorType: vendorType,
      language: lang,
      country,
      size,
      page,
      businessType,
      typeCodeList,
    },
  });
};
// 查询酒店 机票 等是否有最大数量的限制
export const getMaxTicket = (applicationOID) => {
  return fetch({
    url: '/api/travel/application/itinerary/ctrip/exist',
    method: 'GET',
    params: {
      applicationOID: applicationOID,
    },
  });
};

// 获取表单配置
export const getFormProperList = (formOID) => {
  return fetch({
    url: `/api/applications/propertyList/${formOID}`,
    method: 'GET',
  });
};

export const isCityInVendor = (serviceName, cityCode, countryType, businessType, lang = 'zh_cn') => {
  //后台说CHN开头的就要传china
  if (cityCode.indexOf('CHN') !== -1) {
    countryType = 'china';
  } else {
    countryType = 'foreign';
  }
  return fetch({
    url: `/location-service/api/vendor/aliases/${serviceName}/${cityCode}`,
    method: 'GET',
    params: {
      businessType,
      country: countryType,
    },
    headers: {
      language: lang,
    },
  });
};
//获取默认关联申请单
export const getDefaultLoadReferApplication = (formOID, applicantOID) => {
  return fetch({
    url: '/api/loan/reference/my/application/default',
    method: 'POST',
    params: {
      applicantOID: applicantOID,
      formOID: formOID,
    },
    data: {
      withTravelApplication: true,
      withExpenseApplication: true,
      withCustomFormValue: true,
      withBookingApplication: false,
      withLoanApplication: false,
      withUserInfo: true,
      withParticipant: true,
    },
  });
};
// 获取默认借款申请单OID
export const getDefaultLoanApplication = (applicationOID, applicantOID) =>
  fetch({
    url: '/api/loanBill/applicant/default',
    method: 'GET',
    params: {
      applicationOID: applicationOID,
      applicantOID: applicantOID,
      roleType: 'TENANT',
    },
  });

export const getLoanReferApplicationList = ({ params, keyword }) => {
  return fetch({
    url: '/api/loan/reference/applications/V2',
    method: 'POST',
    params: {
      ...params,
      roleType: 'TENANT',
    },
    data: {
      appKeyword: keyword,
      withTravelApplication: true,
      withExpenseApplication: true,
      withBookingApplication: false,
      withLoanApplication: false,
      withUserInfo: true,
      withCustomForm: true,
      withParticipant: true,
      withCustomFormValue: true,
    },
  });
};

export const getRelateApplicationDetail = (applicationOID, type) => {
  let url = '';
  if (type == 1002) {
    // 差旅申请单
    url = '/api/travel/applications/my/get/';
  } else if (type == 1001) {
    // 费用申请单
    url = '/api/expense/applications/';
  } else {
    return;
  }

  return fetch({
    url: url + applicationOID,
    method: 'GET',
  });
};

// 获取表单相关联的费用类型
// export const getRelatedExpenseByFormOID=(formOID,applicationOID='', withReceipt='')=>{
//     if(!formOID){
//
//         return
//     }
//     return fetch({
//         url: `/api/v2/custom/forms/${formOID}/selected/expense/types`,
//         method: 'GET',
//         params:{
//             applicationOID,
//             withReceipt
//         }
//     })
// }
/**
 *  查询申请单行程
 *  原查询接口添加非必填参数 filterItineraryTypes ，数据类型 Integer数组

 *  1001 ： 机票行程，
 *  1002： 火车
 *  1003： 酒店
 *  1004： 其他
 *  1005：行程备注
 *  1006： 差旅补贴
 */
export const getAllItinerary = ({
  isOrigin = false,
  applicationOID,
  newApplicationOID,
  withItemDetail = true,
  withRequestDetail = true,
  filterItineraryTypes = [],
  userOID = '',
  withAllTickets,
}) => {
  let url = isOrigin ? '/api/v2/travel/applications/itinerarys' : '/api/travel/applications/itinerarys';
  return fetch({
    url: url,
    method: 'GET',
    params: {
      applicationOID,
      withAllTickets,
      newApplicationOID,
      withItemDetail,
      withRequestDetail,
      filterItineraryTypes: filterItineraryTypes.join(','),
      userOID,
    },
  });
};

export const getDIDIItinerary = (itineraryOID) => {
  let url = '/api/travel/didi/itinerary';
  return fetch({
    url: url,
    method: 'GET',
    params: {
      itineraryOID,
    },
  });
};

export const getDININGItinerary = (itineraryOID) => {
  let url = '/api/travel/dining/itinerary';
  return fetch({
    url: url,
    method: 'GET',
    params: {
      itineraryOID,
    },
  });
};
// 获取所有供应商列表
export const gtAllSupplierList = (userOID) => {
  let params = {
    userOID: userOID,
  };
  return fetch({
    url: '/api/v2/suppliers',
    method: 'GET',
    params,
  });
};
// 获取审批人自定义表单配置
export const getApprovalCustomForm = (params) => {
  return fetch({
    url: '/api/approval/custom/form',
    method: 'GET',
    params: params,
  });
};
// 获取业务对象数据
export const getFieldConfigNew = (params) => {
  return fetch({
    url: '/api/obj/standard/line/form',
    method: 'GET',
    params: params,
  });
};
// 获取自定义表单配置
export const getCustomForm = (
  formOID,
  userOID = '',
  { formFilterWithOutApproval = false, formFilterValid = false, withUserScope = false } = {}
) => {
  const params = {
    userOID: userOID,
    valid: formFilterValid ? true : undefined,
    withApproval: formFilterWithOutApproval ? false : undefined,
    withUserScope,
  };
  return fetch({
    url: `/api/custom/forms/${formOID}`,
    method: 'GET',
    params,
  });
};
// 获取自定义表单配置
export const getCustomFormPreview = (formOID) => {
  return fetch({
    url: `/api/custom/forms/preview?formOID=${formOID}`,
    method: 'GET',
  });
};
// 获取酒店房间的最大数量
export const postHotelMaxRoom = (participantOIDs, outParticipantNum, applicationOID) => {
  return fetch({
    url: '/api/travel/application/hotel/room/share',
    method: 'POST',
    data: participantOIDs,
    params: {
      externalParticipantNumber: outParticipantNum,
      applicationOID,
    },
  });
};
// 获取单据人数
export const getPersonObj = (applicationOID) => {
  return fetch({
    url: '/api/applications/participantCount',
    method: 'GET',
    params: {
      applicationOID,
    },
  });
};
// 根据时间段生成每天的行程备注结构
export const getRemarkItinerary = (applicationOID, startDate, endDate) => {
  startDate = util.dateFormat(startDate);
  endDate = util.dateFormat(endDate);
  return fetch({
    url: '/api/travel/remark/itinerary/generate',
    method: 'GET',
    params: {
      applicationOID: applicationOID,
      startDate: `${startDate} 00:00:00`,
      endDate: `${endDate} 00:00:00`,
    },
  });
};
// 根据备注日期或者备注详情
export const getRemarkItineraryDetail = (applicationOID, remarkDate) => {
  remarkDate = util.dateFormat(remarkDate);
  return fetch({
    url: '/api/travel/applications/itinerarys',
    method: 'GET',
    params: {
      applicationOID: applicationOID,
      remarkDate: `${remarkDate} 00:00:00`,
    },
  });
};
// 保存行程备注
export const postRemarkItinerary = (applicationOID, data) => {
  return fetch({
    url: '/api/travel/itinerary/remark',
    method: 'POST',
    params: {
      applicationOID: applicationOID,
    },
    data: data,
  });
};
// 获取差补费用类型
export const getTravelSubsidiesV1 = (cityCode, ParticipantOIDs = []) => {
  if (!cityCode || !ParticipantOIDs || !ParticipantOIDs.length) {
    return new Promise((resolve, reject) => {
      reject(false);
    });
  }
  return fetch({
    url: '/api/travelstandardsettings/by',
    method: 'GET',
    params: {
      toCityCode: cityCode,
      userOIDs: ParticipantOIDs.join(','),
    },
  });
};
/**
 *
 * @param {Object} data 确认差补行程v2
 */
export const postTravleSubsidiesDetail = (data) => {
  return fetch({
    url: '/api/travel/subsidies/request/details',
    method: 'POST',
    data,
  });
};
/**
 * 更新差补费用（v2）
 * @param {Object} data
 */
export const putTravelSubsidiesRequestV2 = (data) => {
  return fetch({
    url: '/api/travel/subsidies/request',
    method: 'PUT',
    data: data,
  });
};
/**
 * 获取表单差补规则配置
 * @param formOID
 */
export const getDimension = (formOID) => {
  return fetch({
    url: '/api/travel/subsidies/rule/dimension',
    method: 'GET',
    params: {
      formOID,
    },
  });
};
// 获取差补费用类型（v2）
export const postTravelSubsidiesV2 = ({
  applicationOID,
  id = '',
  startDate,
  endDate,
  cityCode,
  cityName,
  remark,
  expenseTypeOIDs,
  participantOIDs,
  travelSubsidiesCustListDTOs = [],
  itineraryHeadId,
  fromCityCode,
}) => {
  return fetch({
    url: '/api/travel/subsidies/request',
    method: 'POST',
    data: {
      applicationOID,
      id,
      startDate,
      endDate,
      cityCode,
      cityName,
      remark,
      expenseTypeOIDs,
      participantOIDs,
      travelSubsidiesCustListDTOs,
      itineraryHeadId,
      fromCityCode,
    },
  });
};
// 差旅申请一次创建多行程
export const postTravelItineraries = (data) => {
  if (!data) return Promise.reject({ err: errText.noArgs });
  return fetch({
    url: '/api/travel/application/itinerarys',
    method: 'POST',
    data: data,
    timeout: 60000,
  });
};
// 差补更新明细金额（v2）
export const putSubsidiesExpense = (data) => {
  if (!data) return Promise.reject({ err: errText.noArgs });
  return fetch({
    url: '/api/travel/subsidies/detail',
    method: 'PUT',
    data: data,
  });
};
// 根据差补ID获取差补明细（v2）
export const getSubsidieseDetail = (params) => {
  let paramsAry = ['id', 'expenseTypeOIDs', 'areaCodes', 'startDate', 'endDate'];
  let paramsObj = {};
  paramsAry.forEach((item, index) => {
    if (params[item]) {
      if (item.indexOf('Date') != -1) {
        params[item] = moment(params[item]).format('YYYY-MM-DD HH:mm:ss');
      }
      paramsObj[item] = params[item];
    }
  });
  return fetch({
    url: '/api/travel/subsidies/request',
    method: 'GET',
    params: paramsObj,
  });
};
// 删除新差补（v2）
export const deleteSubsidiesDetail = (id) => {
  return fetch({
    url: '/api/travel/subsidies/request',
    method: 'DELETE',
    params: {
      id,
    },
  });
};

// 删除差旅申请中的所有差补（v2）
export const deleteAllSubsidy = (applicationOID) => {
  return fetch({
    url: '/api/travel/subsidies/request/applicationOID',
    method: 'DELETE',
    params: {
      applicationOID: applicationOID,
    },
  });
};

// 删除飞机行程
export const deleteFlightItinerary = (flightItineraryOID) => {
  return fetch({
    url: '/api/travel/flight/itinerary',

    method: 'DELETE',
    params: {
      flightItineraryOID,
    },
  });
};
// 删除火车行程
export const deleteTrainItinerary = (trainItineraryOID) => {
  return fetch({
    url: '/api/travel/train/itinerary',
    method: 'DELETE',
    params: {
      trainItineraryOID,
    },
  });
};
// 删除酒店行程
export const deleteHotelItinerary = (hotelItineraryOID) => {
  return fetch({
    url: '/api/travel/hotel/itinerary',
    method: 'DELETE',
    params: {
      hotelItineraryOID,
    },
  });
};
// 删除其它交通行程
export const deleteOtherItinerary = (otherItineraryOID) => {
  return fetch({
    url: '/api/travel/other/itinerary',
    method: 'DELETE',
    params: {
      otherItineraryOID,
    },
  });
};

// 删除滴滴行程
export const deleteDidiItinerary = (itineraryOID) => {
  return fetch({
    url: '/api/travel/didi/itinerary',
    method: 'DELETE',
    params: {
      itineraryOID,
    },
  });
};

export const deleteDiningItinerary = (itineraryOID) => {
  return fetch({
    url: '/api/travel/dining/itinerary',
    method: 'DELETE',
    params: {
      itineraryOID,
    },
  });
};

// 飞机行程更新
export const putFlightItinerary = (data) => {
  let url = '/api/travel/flight/itinerary';
  return fetch({
    url,
    method: 'PUT',
    params: {
      abandonedItineraryOID: data.abandonedItineraryOID,
    },
    data: data,
  });
};
// 火车行程更新
export const putTrainItinerary = (data) => {
  return fetch({
    url: '/api/travel/train/itinerary',
    method: 'PUT',
    data: data,
  });
};
// 酒店行程更新
export const putHotelItinerary = (data) => {
  return fetch({
    url: '/api/travel/hotel/itinerary',
    method: 'PUT',
    data: data,
  });
};
// 其它行程更新
export const putOtherItinerary = (data) => {
  return fetch({
    url: '/api/travel/other/itinerary',
    method: 'PUT',
    data: data,
  });
};

// 行程停用状态更新
export const getItineraryDisable = (type, params) => {
  return fetch({
    url: `/api/travel/${type}/itinerary/disable`,
    method: 'GET',
    params: params,
  });
};
// 预算检查
export const postCheckBudget = (data) => {
  return fetch({
    url: '/api/travel/applications/checkbudget',
    method: 'POST',
    data: data,
    nativeResponseSerializer: 'boolean',
  });
};
// 随机酒店合住人
export const postRandomBooker = (data) => {
  return {
    url: '/api/travel/application/random/booking/clerk',
    method: 'POST',
    data: data,
  };
};
// 保存申请单
export const postTravelDraft = (data) => {
  return fetch({
    url: '/api/travel/applications/draft',
    method: 'POST',
    data: data,
  });
};
// 提交申请单
export const postTravelSubmit = (data) => {
  return fetch({
    url: '/api/travel/applications/submit/v2',
    method: 'POST',
    data: data,
    timeout: 120000,
  });
};
/**
 * 创建表单时，根据申请人OID和成本中心的OID获取成本中心默认值
 * @param applicantOID
 * @param costCenterOID
 */
export const getDefaultValueOfCostCenter = (applicantOID, costCenterOID) => {
  return fetch({
    url: '/api/bills/default/cost/center/item',
    method: 'GET',
    params: {
      applicantOID: applicantOID,
      costCenterOID: costCenterOID,
    },
  });
};

/**
 * 获取成本中心详情
 * @param costCenterItemOID
 */
export const getCostCenterItemDetail = (costCenterItemOID) => {
  return fetch({
    url: '/api/cost/center/item/' + costCenterItemOID,
    method: 'GET',
  });
};

/**
 * 获取部门信息
 * @param departmentOID
 * @returns {*}
 */
export const getDepartmentDetail = (departmentOID) => {
  return fetch({
    url: '/api/departments/' + departmentOID,
    method: 'GET',
  });
};
/**
 * 判断员工是否开卡
 */
export const postJudgeCardEnable = () => {
  return fetch({
    url: '/api/ctrip/open/card/v2',
    method: 'POST',
  });
};
/**
 * 获取携程单点登录链接
 */
export const getCtripSSOurl = (initPage, approvalNumber = '') => {
  return fetch({
    url: '/api/ctrip/sso',
    method: 'GET',
    params: {
      initPage: initPage,
      approvalNumber: approvalNumber,
    },
  });
};

/**
 * 获取同程订票链接
 */
export const getTongChengOrderUrl = () => {
  return fetch({
    url: '/api/tongcheng/orders/bookurl',
    method: 'GET',
  });
};

/**
 * 获取供应商订票链接
 */
export const getSsoSupplierUrl = (supplierOID, pageType, businessCode) => {
  return fetch({
    url: '/api/suppliers/sso',
    method: 'GET',
    params: {
      supplierOID,
      pageType,
      businessCode,
    },
  });
};

//紧急处理比亚迪的多云支持，后面机制改造下
function getRealmId() {
  let realmId = '';
  if (getH5Platform() === 'cd') {
    NativeService()
      .getUserInfoNative()
      .then((res) => {
        realmId = res.realmId;
      });
  } else {
    const { getTenantProfile } = store.getters;
    realmId = getTenantProfile.realmId;
  }
  if (getBaseUrl().indexOf('https://api-byd.huilianyi.com') >= 0) {
    realmId = '905692682284599319';
  }
  if (getBaseUrl().indexOf('https://console-tc.huilianyi.com') >= 0) {
    realmId = '1005671681484599307';
  }
  //钉钉云
  let urlDomain = window.location.href.split('?')[0];
  if (urlDomain.indexOf('https://dingtalk-dd.huilianyi.com') >= 0) {
    realmId = '639518855899537002';
  }
  return realmId;
}

/**
 * 获取统一订票sso
 */
export const getBookTicketSSOurl = (data) => {
  let realmId = getRealmId();
  return fetch({
    url: '/vendor-info-service/api/sso',
    method: 'GET',
    params: {
      ...data,
      realmId,
    },
  });
};

// export getChangeTicketSSOurl
/**
 * 获取退改签sso
 */
export const getChangeTicketSSOurl = ({
  supplierOID = '',
  pageType,
  businessCode,
  itineraryDirection = null,
  serviceName = null,
  vendorType = '',
}) => {
  let realmId = getRealmId();
  return fetch({
    url: '/vendor-info-service/api/sso/changeOrRefundOrder',
    method: 'GET',
    params: {
      supplierOID,
      pageType,
      orderId: businessCode,
      itineraryDirection,
      serviceName,
      vendorType,
      realmId,
    },
  });
};
/**
 * 获取甄选酒店地址、甄选智能机票退改签地址
 */
export const getHlyHotelTicketSSOur = (data) => {
  let realmId = getRealmId();
  return fetch({
    url: '/vendor-info-service/api/sso/businessCode',
    method: 'GET',
    params: {
      ...data,
      direction: 'H5',
      pageType: 1002,
      realmId,
    },
  });
};
/**
 * 是否进行平台推荐订票
 * @param {*} userOID
 */
export const getShouldRecommandTicket = (userOID) => {
  return fetch({
    url: `/vendor-info-service/api/solr/platform/user/${userOID}`,
    method: 'GET',
  });
};

/**
 * 获取默认供应商
 * @param {String} supplierType
 */
export const getDefaultSupplier = (supplierType) => {
  return fetch({
    url: `/api/suppliers/default/${supplierType}`,
    method: 'GET',
  });
};
/**
 * 获取表单默认值
 * @param {String} userOID
 * @param {String} formOID
 * @param {String} jobId
 * @param {String} key
 */
export const getCustomFormDefaultValues = (userOID, formOID, jobId) => {
  return fetch({
    url: '/api/custom/form/user/default/values',
    method: 'GET',
    params: {
      userOID,
      formOID,
      jobId,
    },
  });
};
export const getDefaultCopyValue = (expenseReportOID, userOID, formOID, jobId) => {
  return fetch({
    url: '/api/expense/reports/copy/drag/in',
    method: 'GET',
    params: {
      expenseReportOID,
      userOID,
      formOID,
      jobId,
    },
  });
};

/**
 * 保存费用申请单--带保存校验逻辑
 * @param data
 * @returns {*}
 */
export const postExpenseApplciationDraftV2 = (data) => {
  //三一iOS App重工提交费用申请有问题， 在iOS上，该报文里面customFormPropertyMap跟三一nginx http1.1 有问题
  let data2 = JSON.parse(JSON.stringify(data));
  delete data2.customFormPropertyMap;
  return fetch({
    url: '/api/expense/applications/draft/v2',
    method: 'POST',
    data: data2,
  });
};

/**
 * 保存费用申请单
 * @param data
 * @returns {*}
 */
export const postExpenseApplciationDraft = (data) => {
  //三一iOS App重工提交费用申请有问题， 在iOS上，该报文里面customFormPropertyMap跟三一nginx http1.1 有问题
  let data2 = JSON.parse(JSON.stringify(data));
  delete data2.customFormPropertyMap;
  return fetch({
    url: '/api/expense/applications/draft',
    method: 'POST',
    data: data2,
  });
};

/**
 *
 * @param data
 * @returns {*}
 */
export const postTravelBookerApplciationDraft = (data) => {
  return fetch({
    url: '/api/travel/booker/applications/draft',
    method: 'POST',
    data,
  });
};

/**
 * 保存借款申请单
 * @param data
 * @returns {*}
 */
export const postLoanApplciationDraft = (data) => {
  return fetch({
    url: '/api/loan/application/draft',
    method: 'POST',
    data,
  });
};

/**
 * 保存差旅申请单
 * @param data
 * @returns {*}
 */
export const postTravelApplciationDraft = (data) => {
  return fetch({
    url: '/api/travel/applications/draft',
    method: 'POST',
    data,
  });
};
/**
 * 保存差旅申请单
 * @param data
 * @returns {*}
 */
export const postTravelApplciationDraftV2 = (data) => {
  return fetch({
    url: '/api/travel/applications/draft/v2',
    method: 'POST',
    data,
  });
};
/**
 * 保存京东申请单
 * @param data
 * @returns {*}
 */
export const postJdApplciationDraft = (data) => {
  return fetch({
    url: '/api/jingdong/order/applications/draft',
    method: 'POST',
    data,
  });
};

/**
 * 根据借款单OID 获取还款历史
 * @param {String} loanBillOid
 */
export const getRepaymentListByLoanBillOID = (loanBillOid) => {
  return fetch({
    url: '/api/repayment/query/by/loanBillOid',
    method: 'GET',
    params: {
      loanBillOid,
    },
  });
};

/**
 * 根据借款行Id 获取还款历史
 * @param {String} loanLineId
 */
export const getRepaymentListByLoanLineId = (loanLineId) => {
  return fetch({
    url: '/api/repayment/query/by/loan/line/id',
    method: 'GET',
    params: {
      loanLineId,
    },
  });
};

/**
 * 通过还款历史oid获取还款记录详情
 * @param {String} repaymentOid
 */
export const getRepaymentDetail = (repaymentOid) => {
  return fetch({
    url: `/api/repayment/detail/${repaymentOid}`,
    method: 'GET',
  });
};

/**
 * 提交还款申请，并通知财务人员
 * @param {Object} refundData 提交还款记录数据
 */
export const postRepaymentSubmit = (refundData) => {
  return fetch({
    url: '/api/repayment/submit',
    method: 'POST',
    data: { ...refundData },
  });
};

/**
 * 提交现金还款申请，并通知财务人员
 * @param {Object} refundData 提交还款记录数据
 */

export const postRepaymentCashSubmit = (refundData) => {
  return fetch({
    url: '/api/repayment/cash/submit',
    method: 'POST',
    data: { ...refundData },
  });
};

/**
 * 创建费用申请单
 * @param data
 * @returns {*}
 */
export const postExpenseApplciation = (data) => {
  return fetch({
    url: '/api/expense/applications/submit/v2',
    method: 'POST',
    data,
  });
};

/**
 * 创建订票申请
 * @param data
 * @returns {*}
 */
export const postTravelBookerApplciation = (data) => {
  return fetch({
    url: '/api/travel/booker/applications/submit',
    method: 'POST',
    data,
  });
};

/**
 * 创建借款申请单
 * @param data
 * @returns {*}
 */
export const postLoanApplciation = (data) => {
  return fetch({
    url: '/api/loan/application/submit',
    method: 'POST',
    data,
  });
};

/**
 * 创建差旅申请单
 * @param data
 * @returns {*}
 */
export const postTravelApplciation = (data) => {
  return fetch({
    url: '/api/travel/applications/submit',
    method: 'POST',
    data,
  });
};

/**
 * 创建京东申请单
 * @param data
 * @returns {*}
 */
export const postJdApplciation = (data) => {
  return fetch({
    url: '/api/jingdong/order/applications/custom/form/submit',
    method: 'POST',
    data,
  });
};

/**
 * 获取币种
 * @params userOID
 * @params language
 * @params enable 是否只查询启用币种（true-启用，false-不启用）
 */
export const getCurrencyCode = (userOID, language = 'chineseName', enable = true) => {
  return fetch({
    url: '/api/company/standard/currency/getAll',
    method: 'GET',
    params: {
      language,
      userOID,
      enable,
    },
  });
};

/**
 * 获取币种v2
 * @params userOId
 * @params setOfBooksId 帐套id(setOfBooksId jobId同时传以setOfBooksId为准)
 * @params language
 * @params enable 是否只查询启用币种（true-启用，false-不启用）
 * @params withRate 是否查询汇率 (true-查询汇率，false-不查询汇率）
 */
export const getCurrencyCodeV2 = (
  userOId,
  language = 'zh_cn',
  enable = true,
  withRate = true,
  jobId = null,
  setOfBooksId = null
) => {
  return fetch({
    url: '/api/currency/status/query/by/setOfBooksId',
    method: 'GET',
    params: {
      language,
      userOId,
      enable,
      withRate,
      jobId,
      setOfBooksId,
    },
  });
};
/**
 * 保存更新的差旅申请单
 * @param data
 * @param lastApplicationOID
 * @returns {*}
 */
export const postUpdateTravelApplication = (data, lastApplicationOID) => {
  return fetch({
    url: `/api/travel/applications/draft/${lastApplicationOID}`,
    method: 'POST',
    data,
  });
};

/**
 * 保存更新费用申请单
 * @param data
 * @param lastApplicationOID
 * @returns {*}
 */
export const postUpdateExpenseApplication = (data, lastApplicationOID) => {
  return fetch({
    url: `/api/expense/applications/draft/${lastApplicationOID}`,
    method: 'POST',
    data,
  });
};

/**
 * 保存更新对公申请单
 * @param data
 * @param lastApplicationOID
 * @returns {*}
 */
export const postUpdateApRequest = (data, lastApplicationOID) => {
  return fetch({
    url: `/api/public/applications/draft/${lastApplicationOID}`,
    method: 'POST',
    data,
  });
};

/**
 * 获取差旅申请单打印pdf地址
 * @param {String} applicationOID
 */
export const getTravelGeneratePdf = (applicationOID) => {
  return fetch({
    url: `/api/travel/application/generate/pdf/${applicationOID}`,
    method: 'GET',
  });
};
/**
 * 获取费用申请单打印pdf地址
 * @param {String} applicationOID
 */
export const getExpenseGeneratePdf = (applicationOID) => {
  return fetch({
    url: `/api/expense/application/generate/pdf/${applicationOID}`,
    method: 'GET',
  });
};
/**
 * 获取借款申请单打印pdf地址
 * @param {String} applicationOID
 */
export const getLoanGeneratePdf = (applicationOID) => {
  return fetch({
    url: `/api/loan/application/generate/pdf/${applicationOID}`,
    method: 'GET',
  });
};
/**
 * 获取对公申请单打印pdf地址
 * @param {String} applicationOID
 */
export const getPrintApRequestPDF = (applicationOID) => {
  return fetch({
    url: `/api/public/application/generate/pdf/${applicationOID}`,
    method: 'GET',
  });
};
/**
 * 获取预算选择历史
 * @param formOID
 * @returns {*}
 */
export const getBudgetTypeHistory = (formOID) => {
  return fetch({
    url: 'api/application/budget/type/history',
    method: 'GET',
    params: {
      formOID,
    },
  });
};

/**
 * 获取值列表描述详情
 * @param filedOID
 * @returns {*}
 */
export const getCustomValueDetail = (filedOID) => {
  return fetch({
    url: `/api/custom/enumerations/${filedOID}/simple`,
    method: 'GET',
  });
};

export const getCustomValueItemDetailV2 = (customEnumerationOID) => {
  return fetch({
    url: `/api/custom/enumerations/${customEnumerationOID}`,
    method: 'GET',
  });
};

/**
 *
 * @param dataFrom
 * @param customEnumerationOID
 * @param value
 * @returns {*}
 */
export const getCustomValueItemDetail = (dataFrom, customEnumerationOID, value) => {
  //dataFrom  102  外部值列表
  if (dataFrom === 102) {
    return fetch({
      url: '/api/custom/enumerations/items/out',
      method: 'GET',
      params: {
        customEnumerationOID,
        messageKey: value,
      },
    });
  } else {
    return fetch({
      url: '/api/custom/enumerations/items',
      method: 'GET',
      params: {
        customEnumerationOID,
        messageKey: value,
      },
    });
  }
};

/**
 * 获取值列表
 * @param dataFrom v2 去除
 * @param customEnumerationOID
 * @param page
 * @param size
 * @param applicantOID
 * @param keyword
 * @returns {*}
 */
export const getCustomValueList = (
  customEnumerationOID,
  page,
  size,
  applicantOID,
  keyword,
  expenseTypeOID,
  setOfBooksId,
  extraParams
) => {
  const { currentItemIdToExpand, useTree } = extraParams || {};
  // let url = "";
  // if (dataFrom === 102) {
  //     url = '/api/custom/enumerations/' + customEnumerationOID + '/items/out';
  // } else {
  //     url = '/api/custom/enumerations/' + customEnumerationOID + '/items/by/user';
  // }
  return fetch({
    url: `/api/custom/enumerations/${customEnumerationOID}/items/v2`,
    method: 'GET',
    params: {
      applicantOID,
      keyword,
      page,
      size,
      expenseTypeOID,
      setOfBooksId,
      currentItemIdToExpand,
      useTree,
    },
  });
};
// 获取外部值列表
export const getOutCustomValueList = (customEnumerationOID, extraParams, needParams = {}) => {
  const { expenseTypeId } = needParams;
  const additionalParam = Base64.encode(JSON.stringify(extraParams));
  let url = `/api/custom/enumerations/${customEnumerationOID}/items/by/user?additionalParam=${additionalParam}`;
  expenseTypeId && (url = `${url}&expenseTypeId=${expenseTypeId}`);
  return fetch({
    url,
    method: 'GET',
  });
};
// 级联对象父查子-通用查询接口
export const getCascadeValueList = (data) => {
  return fetch({
    url: '/api/control/cascade/common/search',
    method: 'POST',
    params: {
      page: data.page,
    },
    data: {
      ...data,
      name: data.keyword,
    },
  });
};
// `/api/custom/enumerations/${field.customEnumerationOID}/items/by/user?additionalParam=${extraParams}`
/**
 * 获取值列表选择历史
 * @param userOID
 * @param fieldOID 值列表OID
 * @returns {*}
 */
export function getCustomValueHistory({ userOID, fieldOID }) {
  return fetch({
    url: '/api/custom/enumeration/item/history',
    method: 'GET',
    params: {
      userOID,
      customEnumerationOID: fieldOID,
    },
  });
  /* 下面接口是 老的 值列表历史 以前的其实挺棒的 是 单据保存后 才会算是 选了某个值列表的项 */
  // return fetch({
  //   url: '/api/custom/enumeration/item/history',
  //   method: 'GET',
  //   params: {
  //     userOID,
  //     customEnumerationOID: fieldOID,
  //   },
  // });
}

/**
 * 删除值列表选择历史
 * @param userOID
 * @param fieldOID
 * @returns {*}
 */
export function deleteCustomValueHistory({ userOID, fieldOID }) {
  return fetch({
    url: '/api/custom/enumeration/item/history',
    method: 'DELETE',
    params: {
      userOID,
      customEnumerationOID: fieldOID,
    },
  });
}

/**
 *
 * @param page
 * @param size
 * @param applicantOID
 * @param keyword
 * @returns {*}
 */
export const getCompanyList = (page, size, applicantOID, keyword) => {
  return fetch({
    url: ' /api/company/by/tenant',
    method: 'GET',
    params: {
      applicantOID: applicantOID,
      name: keyword,
      page: page,
      size: size,
    },
  });
};

/**
 *
 * @param companyOID
 * @returns {*}
 */
export const getCompany = (companyOID) => {
  return fetch({
    url: '/api/companies/noAuthorities/' + companyOID,
    method: 'GET',
  });
};

/**
 *
 * @param corporationEntityOID
 * @returns {*}
 */
export const getCorporationEntity = (corporationEntityOID) => {
  return fetch({
    url: '/api/my/company/receipted/invoice/' + corporationEntityOID,
    method: 'GET',
  });
};
/**
 *
 * @param page
 * @param size
 * @param applicantOID
 * @param keyword
 */
export const getCorporationEntityList = (page, size, applicantOID, keyword) => {
  return fetch({
    url: '/api/v2/my/company/receipted/invoices',
    method: 'GET',
    params: {
      page,
      size,
      applicantOID,
      keyword,
    },
  });
};

/**
 * 获取差旅要素
 * @param formOID
 * @returns {*}
 */
export const getTravelElementsList = (formOID) => {
  return fetch({
    url: '/api/custom/forms/travel/elements/' + formOID,
    method: 'GET',
  });
};

/**
 * 获取注册的供应商
 * @returns {*}
 */
export const getRegisterVendor = () => {
  return fetch({
    url: '/api/register/get/vendor',
    method: 'GET',
  });
};

/**
 * 获取租户配置
 * @param tenantId
 * @returns {*}
 */
export const getTenantConfigByTenantId = (tenantId, setOfBooksId) => {
  return fetch({
    url: '/api/tenant/config/by/tenantId',
    method: 'GET',
    params: {
      tenantId,
      setOfBooksId,
    },
  });
};

/**
 * 搜索位置信息，使用腾讯地图
 * @param keyword
 * @param page_index
 * @param page_size
 * @param filter
 * @param region
 * @param key
 * @returns {*}
 */
export const getLocationsByKeyword = (
  keyword,
  page_index,
  page_size = '10',
  filter,
  region = '',
  key = 'E5XBZ-LWVWJ-2TUFJ-F73PP-VS5LS-W3FUM'
) => {
  /**
   * 宗云哥不给apiuat.huilianyi.com配ws的转发
   */
  let baseUrl = getBaseUrl();
  let urls = ['apiuat.huilianyi.com', 'uat.huilianyi.com', 'apistage.huilianyi.com', 'stage.huilianyi.com'];
  if (urls.some((value) => baseUrl.includes(value))) {
    return fetch({
      baseURL: 'https://apis.map.qq.com',
      url: '/ws/place/v1/suggestion/',
      method: 'GET',
      params: {
        region,
        keyword: encodeURI(keyword),
        key,
        page_index,
        page_size,
        filter: filter ? encodeURI(`category=${filter}`) : undefined,
      },
    });
  } else {
    return fetch({
      url: '/ws/place/v1/suggestion/',
      method: 'GET',
      params: {
        region,
        keyword: encodeURI(keyword),
        key,
        page_index,
        page_size,
        filter: filter ? encodeURI(`category=${filter}`) : undefined,
      },
    });
  }
};

/**
 * 搜索位置信息，使用腾讯地图
 * @param keyword
 * @param page_index
 * @param page_size
 * @param filter
 * @param region
 * @param key
 * @returns {*}
 */
export const getLocationsByKeywordAmap = (
  keyword,
  page_index,
  page_size = '10',
  filter,
  region = '',
  key = '174c8e2d376b5789cebbf78cd59f9e2f',
  language
) => {
  return new Promise((resolve, reject) => {
    let lan = 'ch';
    if (language) {
      lan = language;
    }
    let params = {
      region,
      keywords: keyword,
      key,
      children: 1,
      page: page_index,
      offset: page_size,
      filter: filter ? `category=${filter}` : undefined,
      extensions: 'all',
      language: lan,
    };
    let loginType = getQueryString('loginType');
    let baseUrl = 'https://restapi.amap.com';
    if (
      loginType == 'wx' ||
      loginType == 'wxmp' ||
      loginType == 'dd' ||
      loginType == 'feishu' ||
      loginType == 'welink' ||
      loginType == 'webapp' ||
      loginType == 'yzj'
    ) {
      baseUrl = '/amap';
    }

    if (!loginType) {
      baseUrl = '';
    }

    axios
      .get(baseUrl + '/v3/place/text', { params })
      .then((res) => {
        if (res.status == 200 && res.data) {
          if (res.data.count > 0) {
            resolve(res);
          } else {
            if (res.data.suggestion && res.data.suggestion.cities.length > 0) {
              let cities = res.data.suggestion.cities[0];
              params.city = cities.name;
              axios
                .get(baseUrl + '/v3/place/text', { params })
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            } else {
              resolve(res);
            }
          }
        } else {
          reject('no data');
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getNearLocationsByKeywordAmap = (
  keyword,
  page_index,
  page_size = '10',
  filter,
  region = '',
  key = '174c8e2d376b5789cebbf78cd59f9e2f',
  language,
  location,
  radius
) => {
  return new Promise((resolve, reject) => {
    let lan = 'ch';
    if (language) {
      lan = language;
    }
    let params = {
      location,
      radius,
      keywords: keyword,
      key,
      children: 1,
      page: page_index,
      offset: page_size,
      extensions: 'all',
      language: lan,
    };

    let baseUrl = 'https://restapi.amap.com';
    if (['wx', 'dd', 'lark', 'yzj', 'welink'].includes(getH5Platform())) {
      baseUrl = '/amap';
    }
    axios
      .get(baseUrl + '/v3/place/around', { params })
      .then((res) => {
        if (res.status == 200 && res.data) {
          if (res.data.count > 0) {
            resolve(res);
          } else {
            if (res.data.suggestion && res.data.suggestion.cities.length > 0) {
              let cities = res.data.suggestion.cities[0];
              params.city = cities.name;
              axios
                .get(baseUrl + '/v3/place/around', { params })
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            } else {
              resolve(res);
            }
          }
        } else {
          reject('no data');
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const getNearLocationsByGoogle = ({ keyword, nextPageToken, location, type, radius }) => {
  let key = 'AIzaSyBJyf-ulnWYZ2cRo629GDV1WEXRFS8XwRA';
  let params = {
    key,
    type,
    keyword: keyword,
    radius: radius,
    location,
  };
  nextPageToken && (params.pagetoken = nextPageToken);
  if (config.nativeBusinessFlag && isIOS()) {
    return NativeService().nativeHttpGoogleMap({
      url: 'https://maps.googleapis.com/maps/api/place/nearbysearch/json',
      method: 'GET',
      params: params,
    });
  } else {
    return axios.get('https://maps.googleapis.com/maps/api/place/nearbysearch/json', { params });
  }
};
// https://maps.googleapis.com/maps/api/place/textsearch/json
export const getLocationsByGoogle = ({ keyword, nextPageToken, location, type }) => {
  let key = 'AIzaSyBo7xCk36hTGgaIPLB85hKe5zTx6GQ8miE';
  let params = {
    key,
    type,
    query: keyword,
    radius: 10000,
  };
  nextPageToken && (params.pagetoken = nextPageToken);
  location && (params.location = location);

  if (config.nativeBusinessFlag && isIOS()) {
    return NativeService().nativeHttpGoogleMap({
      url: 'https://maps.googleapis.com/maps/api/place/textsearch/json',
      method: 'GET',
      params: params,
    });
  } else {
    return axios.get('https://maps.googleapis.com/maps/api/place/textsearch/json', { params });
  }
};

export const getLoanApplicationToWriteOff = ({
  page,
  size,
  status,
  applicantOID,
  venMasterId,
  currencyCode,
  companyOID,
}) => {
  let params = {
    page,
    size,
    status,
    applicantOID,
    currencyCode,
    companyOID,
    //venMasterId,
    //roleType: 'TENANT',App上没有这个字段
  };

  if (venMasterId) {
    params.venMasterId = venMasterId;
  }
  return fetch({
    url: '/api/loanBill/applicant',
    method: 'GET',
    params: params,
  });
};

/**
 * 获取申请人的信用分
 * @returns {*}
 */
export const getUserCredit = (params) => {
  return fetch({
    url: '/api/credit/user/info',
    method: 'GET',
    params,
  });
};
export const getCityList = (params) => {
  return fetch({
    url: '/location-service/api/custom/location/search/keyword',
    method: 'GET',
    params: params,
  });
};
export const putDIDIItinerary = (data) => {
  return fetch({
    url: '/api/travel/didi/itinerary',
    method: 'PUT',
    data: data,
  });
};

export const putDININGItinerary = (data) => {
  return fetch({
    url: '/api/travel/dining/itinerary',
    method: 'PUT',
    data: data,
  });
};
export const regulationDidi = (applicantOID, formCode) => {
  return fetch({
    url: '/api/travel/didi/itinerary/regulation',
    method: 'GET',
    params: { applicantOID, formCode },
  });
};
//订票专员
export const getBookCommissioner = () => {
  return fetch({
    url: '/api/authorization/policy/deploy/user/list/v2?type=ROLE_COMPANY_BOOK',
    method: 'GET',
  });
};
//查询列表各种状态单据数量
export const getTabsTotal = () => {
  return fetch({
    url: '/api/application/status/count',
    method: 'GET',
  });
};
//转交
export const deliverApplication = (data) => {
  return fetch({
    url: '/api/application/deliver',
    method: 'POST',
    params: data,
  });
};
//获取订票历史
export const getAutoTicketHistory = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/auto/task/history',
    method: 'GET',
    params: data,
  });
};
//授权自动订票
export const getAutoTicketAuth = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/auto/task/change',
    method: 'GET',
    params: data,
  });
};

//检测能否进行机票预测
export const checkFlightForecast = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/auto/check',
    method: 'GET',
    params: data,
  });
};

//航班查询
export const selectFlight = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/flight/search',
    method: 'GET',
    params: data,
    timeout: 60000,
  });
};

//校验参与人的信息是否完整
export const checkUserInfo = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/auto/user/info/check',
    method: 'GET',
    params: data,
  });
};
//获取预测机票的最新价格
export const getIntelligencePrice = (data) => {
  return fetch({
    url: '/api/travel/flight/itinerary/auto/task/price',
    method: 'GET',
    params: data,
  });
};
//更新检查预算

export const getAllExpenseBudget = (data) => {
  return fetch({
    url: '/api/application/form/expense/budget',
    method: 'GET',
    params: data,
  });
};

//校验护照信息
export const getTravelUserInfo = (data) => {
  return fetch({
    url: '/api/travel/itinerary/user/info/check',
    method: 'GET',
    params: data,
  });
};

//申请单后台校验信息
export const getSubmitApplicationCheck = (params, data) => {
  let paramsUrl = util.revertGetParams(params);
  return fetch({
    url: '/api/application/submit/check' + paramsUrl,
    method: 'POST',
    data,
  });
};

/**
 * 校验直接创建借款单权限
 * @param loanFormOID
 * @param applicantOID
 * @param applicationFormOID
 * @param jobId
 * @returns {*}
 */
export const getCreateLoanAuth = (loanFormOID, applicantOID, applicationFormOID, jobId) => {
  return fetch({
    url: '/api/custom/validate/application/loan',
    method: 'GET',
    params: {
      loanFormOID,
      applicantOID,
      applicationFormOID,
      jobId,
    },
    nativeResponseSerializer: 'boolean',
  });
};

// 根据表单formOID获取属性
export const postPropertysAboutFormOIDs = ({ formOIDs = [], propertyNames = [] }) => {
  return fetch({
    url: '/api/customForm/property/by/formOIDs',
    method: 'POST',
    data: formOIDs,
    params: {
      propertyName: propertyNames,
    },
  });
};

// 获取外部行程链接
export const getOuterLinkByCode = ({ applicationOID, code, itineraryApprovalNumber, outItineraryBusinessCode }) => {
  return fetch({
    url: '/api/travel/out/itinerary',
    method: 'GET',
    params: {
      applicationOID,
      outItineraryCode: code,
      itineraryApprovalNumber,
      outItineraryBusinessCode,
    },
  });
};

// 获取新版外部行程链接
// 需求12779询价，新增rfpId、rfpStatus（1001-可编辑状态，1002-不可编辑状态）
// rfpStatus从申请单入口-1001，从审批入口-1002
export const getNewOuterLinkByCode = (params) => {
  return fetch({
    url: '/vendor-info-service/api/sso/businessCode',
    method: 'GET',
    params,
  });
};

// 回调外部行程
export const getOuterItineraryCallback = (url) => {
  return fetch({
    url: '/api/travel/out/itinerary/callback/forward',
    method: 'GET',
    params: {
      callbackURL: url,
    },
  });
};
// 回调新版外部行程
export const getNewOuterItineraryCallback = (params) => {
  return fetch({
    url: '/api/travel/flight/itinerary/out/vendor',
    method: 'post',
    params,
  });
};
// 根据申请单OID 获取分享用的图片, 目前只支持申请单使用
export const getShareAttachment = (applicationOID) => {
  return fetch({
    url: '/api/travel/share/attachment',
    method: 'GET',
    params: {
      applicationOID,
    },
  });
};
//获取用车类型取值范围
export const getCarType = () => {
  return fetch({
    url: '/api/travel/car/itinerary/types',
    method: 'GET',
  });
};

//判断是否可报销
export const checkCreateReport = (params) => {
  return fetch({
    url: '/api/application/check/create/report',
    method: 'GET',
    params,
  });
};

//自动预算接口
export const postSubsidiesRequest = (params) => {
  return fetch({
    url: '/api/travel/subsidies/request/auto',
    method: 'POST',
    params,
  });
};

// 获取上下级费用
export const postGetUserExpense = (data) => {
  return fetch({
    url: '/api/expense/type/byUser',
    method: 'POST',
    data: data,
  });
};

export const getExpenseDetail = (id) => {
  'use strict';
  return fetch({
    url: `/api/expense/types/select/${id}`,
    method: 'GET',
  });
};

//查询用餐场景
export const getDiningScene = (params) => {
  return fetch({
    url: '/api/dining/scene/form/enable',
    method: 'GET',
    params,
  });
};

//查询关联单据
export const getApplicationReferDoc = (applicationOID, userOID) => {
  return fetch({
    url: '/api/application/refer/documents',
    method: 'GET',
    params: {
      applicationOID,
      userOID,
    },
  });
};

//查询岗位详情
export const getUserJobDetail = (jobId) => {
  return fetch({
    url: `/api/user/jobs/${jobId}`,
    method: 'GET',
  });
};

//获取外部信息
export const getApplicationThirdInfo = (applicationOID) => {
  return fetch({
    url: '/api/application/third/info',
    method: 'GET',
    params: {
      applicationOID,
    },
  });
};
//校验参与人用车制度
export const getCheckRegulation = (data) => {
  return fetch({
    url: '/api/travel/car/itinerary/check/regulation',
    method: 'POST',
    data,
  });
};

//校验参与人用车差标
export const getCheckItineraryStand = (params) => {
  return fetch({
    url: '/api/travel/car/itinerary/user/stand',
    method: 'GET',
    params,
  });
};

export const printRefund = (oid) => {
  return fetch({
    url: '/api/repayment/generate/pdf/' + oid,
    method: 'GET',
  });
};

export const getFinanceConfig = (params) => {
  return fetch({
    url: '/api/repayment/option/getFinanceRepaymentOption',
    method: 'GET',
    params,
  });
};

export const getVisibleCostCenter = () => {
  return fetch({
    url: '/api/cost/center/by/tenant/visible',
    method: 'GET',
  });
};

export const getNewVisibleCostCenter = (data) => {
  let url = '/api/cost/center/item/by/condition/visible';
  return fetch({
    url: url,
    method: 'POST',
    data,
  });
};

export const getVisibleDepartment = (params) => {
  let url = '/api/department/association/company/check';
  return fetch({
    url: url,
    method: 'GET',
    params,
  });
};

// 通过city code 数组 进行 城市名中英文转换
export const translateCity = (lang, cityCode) => {
  return fetch({
    url: '/location-service/api/custom/vendor/alias/cache/codes?language=' + lang,
    method: 'POST',
    data: cityCode,
  });
};

export const getCheckApplicationDate = (params) => {
  let paramsUrl = util.revertGetParams(params);
  return fetch({
    url: '/api/travel/application/date/duplicate/check' + paramsUrl,
    method: 'GET',
  });
};

export const getACardBankList = (params) => {
  'use strict';
  return fetch({
    url: '/api/contact/bank/account/acard',
    method: 'GET',
    params,
  });
};

export const getCreditConfig = (params) => {
  return fetch({
    url: '/api/credit/control/show',
    method: 'GET',
  });
};

export const getRelativeRequest = (formOID, jobId, requestOID) => {
  return fetch({
    url: `/api/loan/reference/applications/value?formOID=${formOID}&jobId=${jobId}`,
    method: 'POST',
    data: requestOID,
  });
};

/**
 * 保存付款申请单
 * @param data
 * @returns {*}
 */
export const postPaymentRequestDraft = (data) => {
  return fetch({
    url: '/api/payment/request',
    method: 'POST',
    data,
    nativeResponseSerializer: 'string',
  });
};
// 获取付款单信息
export const getPaymentRequestDetail = (paymentRequestOID) => {
  return fetch({
    url: `/api/payment/request/${paymentRequestOID}`,
    method: 'GET',
  });
};

//获取退回至的节点列表
export const getReturnNodeList = (params) => {
  let url = 'api/approvals/passing/history';
  return fetch({
    url: url,
    method: 'POST',
    data: params, // post 把参数放在body里，不要直接拼接在url后面
  });
};

//回退至某节点
export const returnToNode = (params) => {
  let url = '/api/approvals/go/back';
  return fetch({
    url: url,
    method: 'POST',
    data: params,
  });
};

//保存对公支付单
export const postCorpPayment = (data) => {
  return fetch({
    url: '/api/expense/reports/custom/form/draft?corporateFlag=true',
    method: 'POST',
    data: { ...data, isDateCombinedUTC: false },
  });
};

// 获取对公支付单可关联的采购申请单列表
export const getCorpRelateApplicationList = (params) => {
  const { page, size, ...data } = params;
  return fetch({
    url: `/api/public/applications/search/list/v2?page=${page}&size=${size}`,
    method: 'POST',
    data,
  });
};
// 合同关联申请单
export const getContractRelateApplicationList = (params) => {
  return fetch({
    url: '/api/contract/applications/search',
    method: 'GET',
    params,
  });
};

//报废操作
export const associateApplication = (applicationOID, data) => {
  return fetch({
    url: 'api/applications/invalid',
    method: 'POST',
    params: {
      applicationOID,
    },
    data,
  });
};

// 校验差旅行程高风险地区
export const checkRiskCity = (applicationOID) => {
  return fetch({
    url: '/api/travel/application/city/risk/check',
    method: 'GET',
    params: {
      applicationOID,
    },
  });
};

// 参与人校验
export const getVisibleParticipant = (params, roleType = 'TENANT') => {
  const { formOID = '', departmentOID, proposerOID, costCentreOID = [], jobId, participantsOID } = params || {};
  return fetch({
    url: '/api/application/participant',
    method: 'POST',
    params: {
      formOID,
      departmentOID,
      proposerOID,
      costCentreOID: costCentreOID.toString() || undefined,
      roleType,
      jobId,
    },
    data: participantsOID,
  });
};
export const getSupplierVenInfo = (page, size, keyword, companyOid) => {
  return fetch({
    url: '/supplier/api/ven/info/by/company',
    method: 'GET',
    params: {
      page,
      size,
      keyword,
      companyOid,
    },
  });
};
export const isCitiesInVendor = (cityList, lang = 'zh_cn') => {
  return fetch({
    url: '/location-service/api/vendor/aliases/vendorType/code/batch',
    method: 'POST',
    headers: {
      language: lang,
    },
    data: cityList,
  });
};
export const getCompanyBank = (page, size, keyword) => {
  return fetch({
    url: '/api/CompanyBank/query?enabled=true',
    method: 'GET',
    params: {
      page,
      size,
      keyword,
    },
  });
};
// 关联单据列表
export const getLinkFormList = (page, size, data) => {
  return fetch({
    url: `/api/document/rla/get/rla/list?page=${page}&size=${size}`,
    method: 'POST',
    data,
  });
};
// 共享控件关联单据带值
export const getShareValues = (params) => {
  return fetch({
    url: '/api/custom/form/mapping/values',
    method: 'GET',
    params,
  });
};
// 关联单据查询
export const getLineFormLevelList = (entityOID) => {
  return fetch({
    url: '/api/document/rla/get/level',
    method: 'POST',
    data: {
      entityOID,
    },
  });
};

// 校验消费商是否授权个人信息
export const checkAuthorization = (userOIDs, vendorOIDs) => {
  return fetch({
    url: '/auth/api/user/vendor/authority/by/vendor',
    method: 'POST',
    data: {
      userOIDs,
      vendorOIDs,
    },
  });
};

// 个人信息授权
export const authorizeInfo = (vendorOIDs) => {
  return fetch({
    url: '/api/user/vendor/authority/grant/by/vendor/oid',
    method: 'POST',
    data: {
      vendorOIDs,
    },
  });
};

export const checkBookStatus = (params) => {
  return fetch({
    url: '/api/travel/application/itinerary/book/enable',
    method: 'GET',
    params,
  });
};

export const getChangeLog = (params) => {
  return fetch({
    url: '/api/applications/change/compare',
    method: 'GET',
    params,
  });
};

/**
 * 新版申请单查询预算关闭详情
 */
export const getNewBudgetCloseList = (applicationOID) => {
  return fetch({
    url: `api/application/itinerary/budget/close/list?applicationOID=${applicationOID}`,
    method: 'GET',
  });
};

// 获取用车场景
export const getCarScene = () => {
  return fetch({
    url: '/api/travel/car/scene/list',
    method: 'GET',
  });
};

// 查询当前单据对应的第一个版本的提交时间
export const getSubmitDate = (applicationOID) => {
  return fetch({
    url: `/api/application/first/version/submitteddate?applicationOID=${applicationOID}`,
    method: 'GET',
  });
};

// 批量获取值列表项的值
export const getCustomEnumerationItems = (data) => {
  return fetch({
    url: 'api/custom/enumeration/items/oids',
    method: 'POST',
    data,
  });
};

// 查询申请单分摊相关人（参与人+申请人）
export const getRelevantPerson = (applicationOID, page, size, keyword) => {
  return fetch({
    url: '/api/application/relevant/participant',
    method: 'GET',
    params: {
      applicationOID,
      page,
      size,
      keyword,
    },
  });
};

// 判断行程是否可以预订
export const getBookStatus = (params) => {
  return fetch({
    url: '/api/travel/approval/enable',
    method: 'GET',
    params,
  });
};

// 控件系统计算
export const getSystemCalculate = (data, applicantOID) => {
  return fetch({
    url: `/api/custom/system/calculate/values?applicantOID=${applicantOID || null}`,
    method: 'POST',
    data,
  });
};

// 控件系统计算
export const getSystemCalculateV2 = (data, applicantOID) => {
  return fetch({
    url: `/api/custom/system/calculate/values/v2?applicantOID=${applicantOID || null}`,
    method: 'POST',
    data,
  });
};

// 系统计算回调模式
export const getCallBackCalculate = (data) => {
  return fetch({
    url: '/api/custom/system/calculate/callback',
    method: 'POST',
    data,
  });
};

// 根据物料编码查物料详情
export const getMaterialInfo = (code) => {
  return fetch({
    url: `/api/materialInfo/byMaterialCode?materialCode=${code}`,
    method: 'GET',
  });
};

// 物料分页 标的物物料权限管控
export const getMaterials = (params) => {
  const { page, size } = params;
  delete params.page;
  delete params.size;
  return fetch({
    url: `/api/materialInfo/page?page=${page}&size=${size}`,
    method: 'POST',
    data: {
      enabled: true,
      ...params,
    },
  });
};

// 新单位分页
export const getUnits = (params) => {
  return fetch({
    url: '/api/measurementUnit/page',
    method: 'GET',
    params,
  });
};

// 多币种金额转换
export const transferAmount = (params) => {
  return fetch({
    url: '/api/applications/multi/currency/amount',
    method: 'GET',
    params,
  });
};

export const getExtendField = () => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/api/custom/forms/view?formType=1901&withApproval=false',
      method: 'GET',
    })
      .then((res) => {
        const { customFormFields = [] } = res.data;
        res.data.fixFormFields = customFormFields.filter((item) => item.dataType === 'fix');
        res.data.customFormFields = customFormFields.filter((item) => item.dataType === 'custom');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 超标原因
export const updateExceededReason = (applicationOID, params) => {
  return fetch({
    url: `api/application/itinerary/budget/update/exceeding/reason?applicationOID=${applicationOID}`,
    method: 'POST',
    data: params,
  });
};

// 获取其他场景
export const getOtherScene = () => {
  return fetch({
    url: '/api/travel/other/scene/list',
    method: 'GET',
  });
};

export const getFormTypes = () => {
  return fetch({
    url: '/api/custom/forms/list?page=0&size=1000',
    method: 'POST',
    data: {},
  });
};

// 获取系统计算因子
export const getCalculateField = (formOID, entityOID) => {
  let extraParams = entityOID ? `&entityOID=${entityOID}` : '';
  return fetch({
    url: `/api/custom/form/value/field/calculate?formOID=${formOID}` + extraParams,
    method: 'GET',
  });
};

// 查询申请单预算报销情况
export const getApplicationBudgetInfo = (applicationOID) => {
  return fetch({
    url: `/api/applications/budget/reimbursed/info?applicationOID=${applicationOID}`,
    method: 'GET',
  });
};

export const getCompanyGroup = (params) => {
  return fetch({
    url: '/api/company/group/query/dto',
    method: 'GET',
    params: params,
  });
};

export const getDepartmentGroups = (params) => {
  return fetch({
    url: '/api/DepartmentGroup/selectDepartmentGroupByInput',
    method: 'GET',
    params: params,
  });
};

// 出行政策查询
export const getTravelPolicySearch = (params) => {
  return fetch({
    url: '/location-service/api/additional/area/additional/area/check?' + params,
    method: 'GET',
  });
};

// 校验费用类型是否在项目任务范围下
export const checkTaskExpense = (data) => {
  return fetch({
    url: 'api/check/expense/type/byTask',
    method: 'POST',
    data,
  });
};

//批量删除费用明细
export const deleteBatchBudget = (data) => {
  return fetch({
    url: 'api/application/itinerary/budget/batch/delete',
    method: 'POST',
    data,
  });
};

// 获取明细表单，type 1901是行程头表单
export const getStandardLineField = (type, formOID) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: `/api/obj/standard/line/field/page?type=${type}&formOID=${formOID}`,
      method: 'GET',
    })
      .then((res) => {
        res.data.fixFormFields = res.data.filter((item) => item.dataType === 'fix');
        res.data.customFormFields = res.data.filter((item) => item.dataType === 'custom');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 以下是简易申请单相关接口
export const getExpenseProperty = (formOID) => {
  return fetch({
    url: `/api/travel/simple/itinerary/expense/property?formOID=${formOID}`,
    method: 'GET',
  });
};

export const getExpensePropertyV2 = (formOID, data) => {
  return fetch({
    url: `/api/travel/simple/itinerary/expense/property/v2?formOID=${formOID}`,
    method: 'POST',
    data,
  });
};

export const getQuickItineraryList = (params) => {
  return fetch({
    url: '/api/travel/common/itinerary/page/list',
    method: 'GET',
    params,
  });
};

// 最新创建的行程（10分钟内创建，最多5条）
export const getQuickItineraryLast = (params) => {
  return fetch({
    url: '/api/travel/common/itinerary/page/last',
    method: 'GET',
    params,
  });
};

// 可提交审批 行程数量
export const getQuickItineraryCount = (params) => {
  return fetch({
    url: '/api/travel/common/itinerary/list/count',
    method: 'GET',
    params,
  });
};

export const bindBatchBudget = (applicationOID, data) => {
  return fetch({
    url: 'api/application/itinerary/budget/binding',
    method: 'POST',
    params: { applicationOID },
    data,
  });
};

export const releaseBatchBudget = (applicationOID, data) => {
  return fetch({
    url: 'api/application/itinerary/budget/relieve',
    method: 'POST',
    params: { applicationOID },
    data,
  });
};

/**
 * 简易申请单获取自动预算
 */
export const getQuickTripRuleBudget = (params) => {
  return fetch({
    url: '/api/travel/rule/budget/v2',
    method: 'GET',
    params,
  });
};

//新建／保存数据记录
export const saveBusinessRecordData = (data) => {
  return fetch({
    url: '/api/cusformObj/save',
    method: 'POST',
    data,
  });
};

//获取数据记录详情
export const getBusinessRecordDetail = (id, ...args) => {
  const { userOID } = args[1] || {};
  return fetch({
    url: `/api/cusformObj/findOne?id=${id}`,
    method: 'GET',
    params: { userOID },
  });
};

//获取数据记录详情
export const getOrderRecordList = (idList, applicationOID) => {
  let paramsUrl = util.revertGetParams({
    orderIds: idList,
    applicationOID,
    page: 0,
    size: 1000,
  });
  return fetch({
    url: '/api/public/srm/order/search' + paramsUrl,
    method: 'GET',
  });
};

// 申请单关联合同列表
export const getRelateContractList = (page, size, data) => {
  return fetch({
    url: `/contract/api/contract/header/associate/query?page=${page}&size=${size}`,
    method: 'POST',
    data,
  });
};

// 申请单关联合同共享控件带值
export const getContractShareValues = (params) => {
  return fetch({
    url: '/api/custom/form/share/values',
    method: 'GET',
    params,
  });
};
//获取共享控件的值-业务组自己使用-申请单
export const getFieldDataApplication = (data) => {
  return fetch({
    url: '/api/application/form/values/mapping',
    method: 'POST',
    data,
  });
};

// 获取币种默认值
export const getCurrencyValue = (params) => {
  return fetch({
    url: '/api/custom/form/currency/code',
    method: 'GET',
    params,
  });
};
// 查询飞书审批实例
export const getApprovalInstance = (data) => {
  return fetch({
    url: '/api/feishu/find/approval/instance',
    method: 'POST',
    data,
  });
};
// 查询单个飞书审批实例信息并抄送给当前登录人
export const getApprovalInstanceAndCC = (data) => {
  return fetch({
    url: '/api/feishu/get/approval/instance/and/cc',
    method: 'POST',
    data,
  });
};

// 查询对公申请单预算报销情况
export const getPublicApplicationBudgetInfo = (applicationOID) => {
  return fetch({
    url: `/api/public/applications/budget/reimbursed/info?applicationOID=${applicationOID}`,
    method: 'GET',
  });
};

// 获取当前城市
export const getCurrentLocation = (data) => {
  return fetch({
    url: '/location-service/api/custom/location/getCurrentLocation',
    method: 'POST',
    data,
  });
};

/*
 * 参与人可见范围区域组
 * */
export const getCityGroup = (data) => {
  return fetch({
    url: '/api/levels/org/area/group',
    method: 'POST',
    data,
  });
};

/*
 * 城市组下城市列表
 * */
export const groupCityList = (params) => {
  return fetch({
    url: '/api/areas/level/search/keyword/v3',
    method: 'GET',
    params,
  });
};

// 城市组消费商校验
export const isCityGroupInVendor = (vendorType, cityGroupCode, supplierOID) => {
  return fetch({
    url: `/location-service/api/vendor/aliases/${vendorType}/${cityGroupCode}`,
    method: 'GET',
    params: {
      supplierOID,
    },
  });
};

//校验部门角色权限
export const checkDepartmentRole = (data) => {
  return fetch({
    url: '/api/departmentposition/filter/by/useroid/and/codes',
    method: 'POST',
    data,
  });
};

//校验成本中心角色权限
export const checkCostCenterRole = (data) => {
  return fetch({
    url: '/api/cost/center/position/filter/by/useroid/and/codes',
    method: 'POST',
    data,
  });
};

export const getContractHeaderInfo = (id) => {
  return fetch({
    url: `/contract/api/contract/header/${id}`,
    method: 'GET',
  });
};
